import moment from "moment";

export default {
  data() {
    return {
    };
  },
  methods: {

    setWaveSelection(_this, opt) {
      let lastYearInList = _.max(_.map(opt.Waves, function(w) { return moment(w.WaveDate, moment.ISO_8601).year(); } ));
      if (lastYearInList > moment().year()) {
        lastYearInList = moment().year();
      }
      let areAllWavesSelected = _.every(opt.Waves, function(wave) {
        return wave.IsDefault !== 1 &&
               moment(wave.WaveDate, moment.ISO_8601).year() === lastYearInList;
      });
      if (areAllWavesSelected) {
        return;
      }

      let newWaves = [];
      opt.Waves.forEach(wave => {
        if (wave.IsDefault === 1 && wave.year >= lastYearInList)
          newWaves.push(wave.id);
      });
      _this.selection.Waves = newWaves;
    },

    // TODO: Dieser Teil kann sehr wahrscheinlich entfallen!!!!!
    initializeActiveSurveyYears(_this, opt, customize) {
      let years = [];

      _this.selection.Surveys.forEach(x => {
        let item = _.find(opt.Surveys, ['id', x]);
        if (item && !years.includes(item.year)) {
          years.push(item.year);
        }

        if (item && item.label.includes('BMW Motorrad') && !years.includes(2017)) {
          years.push(2017);
          years.push(2018);
          years.push(2019);
          years.push(2020);
        }
      });
      if (customize === 'compare') {
        if (years.includes(2021) && !years.includes(2020)) {
          years.push(2020);
        }
      }

      // HACK: get all years from 2022 until today
      // HACK: get all years from 2021 until today ... 04.07.2024 
      //       but not sure why!
      let currentYear = moment().year();
      for (let i = 2021; i <= currentYear; i++) {
        if (!years.includes(i)) {
          years.push(i);
        }
      }

      _this.years =_.sortBy(years);
    },

    initializeWaveYear(_this, opt) {
      if(opt == null || opt.Waves == null)
        return;

      opt.Waves.forEach(w => {
        if (w.label.startsWith('2021_Q') &&  moment(w.WaveDate, moment.ISO_8601).year() != 2021) {
          w.WaveDate = moment("2021-01-01");
        }
        w.year = moment(w.WaveDate, moment.ISO_8601).year();
      });
      _.remove(opt.Waves, w => {
        return !_this.years.includes(w.year);
      });
    },

    initializeSelectedWaves(_this, opt) {
      let items = [];
      _this.selection.Waves.forEach(w => {
        items.push(w);
      });
      _.remove(items, w => {
        let item = _.find(opt.Waves, ['id', w]);
        if (!item) {
          return true;
        }
        return !_this.years.includes(item.year);
      });
      _this.selection.Waves = items;
    },

    getSelectedWaveYears(_this, opt) {
      let items = [];
      if (opt.Waves) {
        opt.Waves.forEach(w => {
          if (_this.selection.Waves.includes(w.id)) {
            if (_this.years.includes(w.year) && !items.includes(w.year) ) {
              items.push(w.year);
            }
          }
        });
      }
      return items;
    },

    // this.initializeWaves(_this, sender, opt, 'compare', true);
    initializeWaves(_this, sender, opt, customize, allWaves) {
      _this.initializeActiveSurveyYears(_this, opt, customize);
      _this.initializeWaveYear(_this, opt);
      _this.initializeSelectedWaves(_this, opt);

      if (sender === 'mounted' ||
          sender === 'Brand' ||
          sender === 'Surveys' ||
          _this.selection.Waves.length === 0) {

        // Remove if not in corr Waves
        this.filterSurveys(_this, opt);

        if (this.autoFilter.isEnabled && opt.Waves.length > 0) {
          if (allWaves) {
            for (const w of opt.Waves) {
              if (!_this.selection.Waves.includes(w.id))
                _this.selection.Waves.push(w.id);
            }
          } else {
            // Select up to last 4 waves as default
            for (const w of _.orderBy(opt.Waves, ['year', 'WaveDate'], ['asc', 'asc']).slice(-4)) {
              if (w && !_this.selection.Waves.includes(w.id))
                _this.selection.Waves.push(w.id);
            }

            // this.setWaveSelection(_this, opt);
          }
        }
      }

      _this.yearsbywave = _this.getSelectedWaveYears(_this, opt);
    }
  }
};
